import {MenuItem, styled} from "@mui/material";

export const UserMenuItem = styled(MenuItem)(() => ({
    display: 'flex',
    width: '316px',
    padding: '17px 37px 17px 37px',
    gap: '19px',

    '@media screen and (max-width: 768px)': {
        padding: '6px 37px',
    }
}));

export const UserMenuNameItem = styled(UserMenuItem)(() => ({
    display: 'flex',
    justifyContent: 'center',
    '&.MuiMenuItem-root': {
        opacity: 1,
        overflow: 'hidden',
    }
}));

export const UserMenuImageItem = styled(UserMenuItem)(() => ({
    display: 'flex',
    justifyContent: 'center',
    '&.MuiMenuItem-root': {
        opacity: 1
    }
}));

export const UserLogoutMenuItem = styled(UserMenuItem)(({theme}) => ({
    color: theme.barekam.header.logoutButton.color
}));
